import axios from 'axios';

export default class NewsletterForm {
  constructor() {
    this.$success = document.querySelector('.c-newsletter__success');
    this.$main = document.querySelector('.c-newsletter__main');
    this.$form = document.querySelector('.c-newsletter__form');
    this.$successDescription = this.$success.querySelector('p');
    this.$emailInput = this.$form.querySelector('input[type="email"]');

    this.ajaxAction = 'newsletter_form';

    this.$form.addEventListener('submit', this.onSubmit.bind(this));
  }

  /**
   * @function onSubmit
   * @param {Event} e
   */
  onSubmit(e) {
    e.preventDefault();

    const formData = new FormData(this.$form);
    const params = new URLSearchParams();

    params.append('action', this.ajaxAction);

    // Fill out the request
    for (const key of formData.keys()) {
      params.append(key, formData.get(key));
    }

    axios
      .post(window.site.api.ajax, params)
      .then(res => this.onSuccess(res));
  }

  /**
   * @function onSuccess
   * @param {Object} res
   */
  onSuccess(res) {
    if (res.errors) {
      return this.onError(res);
    }

    // Update the success description variable with the emil address
    this.$successDescription.innerText = this.$successDescription.innerText.replace('{{email}}', this.$emailInput.value);

    // Update the view to show the success state
    this.$success.classList.add('is-visible');
    this.$main.remove();

    return true;
  }
}
